import i18next from 'i18next';

i18next.addResources('es', 'projectDetail', {
  zoomMap: 'Ampliar mapa',
  countries: 'Países',
  territories: 'Territorios',
  dollarsInvested: 'Inversión estimada (USD Miles)',
  projects: 'Proyectos y Acciones'
});

i18next.addResources('en', 'projectDetail', {
  zoomMap: 'Zoom map',
  countries: 'Countries',
  territories: 'Territories',
  dollarsInvested: 'Estimated investment (USD thousands)',
  projects: 'Projects and Actions'
});

i18next.addResources('pt', 'projectDetail', {
  zoomMap: 'Ampliar mapa',
  countries: 'Países',
  territories: 'Territórios',
  dollarsInvested: 'Investimento estimado (USD mil)',
  projects: 'Projetos e Ações'
});
